import NumberInput from "../NumberInput";

class ProductDetail {
	constructor(config) {
		this.config = Object.assign({
			scope: '.product-detail'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		new NumberInput();
	}

}

export default new ProductDetail;